<template>
  <div class="error404-page">
    <div class="container error404-container">
      <img :src="content.image" alt="Error 404" class="error404-image" />
      <div class="error404-error">{{ content.error }}</div>
      <div class="error404-oops">{{ content.oops }}</div>
      <p class="error404-desc">{{ content.description }}</p>
      <div class="error404-whatdo">{{ content.whatDo }}</div>
      <ul class="error404-bullets">
        <li v-for="(b, i) in content.bullets" :key="i" v-html="b"></li>
      </ul>
      <div class="error404-sorry">{{ content.sorry }}</div>
    </div>
    <SiteFooter :selectedLang="selectedLang" />
  </div>
</template>

<script>
import { useSEO } from '@/composables/useSEO';
import { error404Content } from '@/assets/data/data.ts'
import SiteFooter from '@/components/SiteFooter.vue'

export default {
  name: "ErrorPage404",
  props: {
    selectedLang: {
      type: String,
      default: "es"
    }
  },
  setup() {
    useSEO({
      title: 'Página no encontrada',
      description: 'La página que buscas no existe. Regresa al inicio o explora nuestros servicios de Industria 4.0 y automatización industrial.',
      path: '/error-404',
      robots: 'noindex, follow',
    });
  },
  computed: {
    content() {
      return error404Content[this.selectedLang] || error404Content.es
    }
  },
  components: { SiteFooter }
}
</script>

<style scoped>
.error404-page {
  background: #fff;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}
.error404-container {
  max-width: 740px;
  margin: 0 auto;
  text-align: justify;
  padding: 40px 20px 0 20px;
}
.error404-image {
  max-width: 330px;
  width: 100%;
  margin: 0 auto 18px auto;
  display: block;
}
.error404-error {
  font-family: 'IBM Plex Mono', monospace;
  font-size: 2.8rem;
  font-weight: bold;
  color: #24292f;
  margin-bottom: 14px;
}
.error404-oops {
  font-family: 'Caveat-Bold', cursive;
  font-size: 2.15rem;
  margin-bottom: 13px;
  color: #101;
}
.error404-desc {
  font-family: 'IBM Plex Mono', monospace;
  font-size: 1.08rem;
  color: #232323;
  margin-bottom: 12px;
}
.error404-whatdo {
  font-family: 'IBM Plex Mono', monospace;
  font-size: 1.14rem;
  font-weight: bold;
  margin-bottom: 4px;
  margin-top: 16px;
  color: #222;
}
.error404-bullets {
  text-align: justify;
  font-family: 'IBM Plex Mono', monospace;
  font-size: 1.01rem;
  color: #232323;
  margin: 0 auto 12px auto;
  max-width: 500px;
  padding-left: 1.2em;
  margin-bottom: 20px;
}
.error404-bullets li {
  margin-bottom: 7px;
  list-style: disc inside;
}
.error404-bullets li a {
  color: #007aff;
  text-decoration: underline;
}
.error404-sorry {
  font-family: 'IBM Plex Mono', monospace;
  font-size: 1.02rem;
  color: #444;
  margin-bottom: 24px;
}
</style>
